import HttpClient from "./HttpClient";

export default class WorkCenterDependency{
    constructor(dependency){
        this.id = dependency.id;
        this.depends_on = dependency.depends_on;
        this.work_center_id = dependency.work_center_id;
        this.created_at = dependency.created_at;
        this.updated_at = dependency.updated_at;
    }

    static async create(data){
        const client = new HttpClient();
        const response = await client.instance.post(`work-center-dependencies`, data);
        return response.data;
    }

    async remove(){
        const client = new HttpClient();
        const response = await client.instance.delete(`work-center-dependencies/${this.id}`);
        return response.data;
    }
}